import React from "react";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import { type IKuikaButtonStatusLabels, type KuikaButtonStatus } from "../../ui-kit/kuika-button/kuika-button";
import KuikaModalIconWrapper from "../../ui-kit/kuika-modal-icon-wrapper";
import KuikaH5 from "../../ui-kit/typography/H5/H5";
import KuikaText from "../../ui-kit/typography/Text/Text";
import "./branching-modal.scss";

export interface ISwitchBranchWarningModalProps {
  showModal: boolean;
  targetBranchName?: string;
  changeCount: number;
  inProgress?: boolean;
  /**
   * Where the switch stands (`KuikaButton` `status`). Given, SWITCH ANYWAY carries it — the busy
   * word, then its ✓ or "Try again" — and `inProgress` no longer draws on it.
   */
  status?: KuikaButtonStatus;
  onClose: () => void;
  onConfirm: () => void;
}

const SWITCH_STATUS_LABELS: IKuikaButtonStatusLabels = { loading: "Switching", success: "Switched" };

const SwitchBranchWarningModal: React.FC<ISwitchBranchWarningModalProps> = ({
  showModal,
  targetBranchName,
  changeCount,
  inProgress,
  status,
  onClose,
  onConfirm
}) => {
  // The ✓ is up until the dialog leaves: there is nothing left to cancel then.
  const footer = (
    <KModalFooter
      closesOnSuccess
      onCancel={onClose}
      submitLabel="Switch anyway"
      submitTestId="switchBranchAnywayButton"
      onSubmit={onConfirm}
      loading={inProgress}
      status={status}
      statusLabels={SWITCH_STATUS_LABELS}
    />
  );

  return (
    <KModal
      showModal={showModal}
      closeModal={onClose}
      header="Uncommitted Changes"
      footer={footer}
      width={380}
      centered
    >
      <div className="kuika-branching-modal">
        <div className="kuika-branching-modal__header">
          <KuikaModalIconWrapper iconName="alert-triangle" intent="warning" />
          <div className="kuika-branching-modal__title">
            <KuikaH5>Uncommitted Changes</KuikaH5>
          </div>
        </div>
        <div className="kuika-branching-modal__content">
          <div className="kuika-branching-modal__description">
            <KuikaText>
              This branch has {changeCount} uncommitted change{changeCount === 1 ? "" : "s"}. Switching
              {targetBranchName ? ` to “${targetBranchName}”` : " branches"} reloads the project — commit them first if
              you want to keep them on this branch.
            </KuikaText>
          </div>
        </div>
      </div>
    </KModal>
  );
};

export default SwitchBranchWarningModal;
